import React from 'react';
import { useIntl } from 'react-intl';
import { Evidence, useDatedEvidence } from '@eas/common-web';
import { ExportTags } from '../../../common/export-tags';
import { Registration } from '../../../common/models';
import { RegistrationFields } from './registrations-fields';
import { useColumns } from './registrations-columns';
import { RegistrationsToolbar } from './registrations-toolbar';
import { useValidationSchema } from './registration-schema';

export function OperatorRegistrations() {
  const intl = useIntl();
  const validationSchema = useValidationSchema();

  const evidence = useDatedEvidence<Registration>({
    identifier: 'REGISTRATIONS',
    apiProps: {
      url: '/api/ks/registrations',
    },
    tableProps: {
      columns: useColumns(),
      tableName: intl.formatMessage({
        id: 'KS_O_REGISTRATIONS_TABLE_TITLE',
        defaultMessage: 'Registrace',
      }),
      reportTag: ExportTags.REGISTRATION_GRID,
    },
    detailProps: {
      FieldsComponent: RegistrationFields,
      validationSchema,
      toolbarProps: {
        after: <RegistrationsToolbar />,
        showButton: () => false,
      },
    },
  });

  return <Evidence {...evidence} />;
}
